<script setup lang="ts">
import { inject, reactive, ref } from 'vue'
import { req } from '@/api'
import { store } from '@/pinia/store'
import { getUrlData, replace } from '@/utils'
import { showToast } from '@/hooks/useVant'
import { onBeforeRouteLeave, useRouter } from 'vue-router'

const storeData = store()
const isShowConfirmPopup = inject('isShowConfirmPopup', ref(false))
const globalUgcTechDislikeInfo = inject<any>('globalUgcTechDislikeInfo', reactive({}))
const themeVars = reactive({
  overlayBackground: 'rgba(0, 0, 0, 0.3)',
})
const router = useRouter()

onBeforeRouteLeave(() => {
  if (isShowConfirmPopup.value) {
    isShowConfirmPopup.value = false
    return false
  }
})

// 不喜欢ta、不看ta
const addOrRemove = async () => {
  const res = await req
    .addOrRemove({
      action: 1,
      id: globalUgcTechDislikeInfo?.id,
      type: 1,
      techReltype: globalUgcTechDislikeInfo?.type,
    })
    .catch(() => {
      showToast('设置失败！')
    })
  if (res && res?.code === 0) {
    showToast('设置成功！')
    globalUgcTechDislikeInfo?.type === 0
      ? storeData.unlikeIdList?.techIds.push(globalUgcTechDislikeInfo?.id)
      : storeData.unlikeIdList?.ignoreShowTechIds.push(globalUgcTechDislikeInfo?.id)
    storeData.globalUgcInfo.actionTimestamp = new Date().getTime()
    isShowConfirmPopup.value = false
    if (
      ['trendsDetail', 'techProfile'].includes(router.currentRoute.value.name.toString()) ||
      (['technicianDetail'].includes(router.currentRoute.value.name.toString()) &&
        globalUgcTechDislikeInfo?.type === 0 &&
        globalUgcTechDislikeInfo?.id === getUrlData('techId'))
    ) {
      const fromOrigin = storeData.globalUgcInfo.fromOrigin
      if (fromOrigin === '0') {
        // 首页
        replace('/index')
      } else if (fromOrigin === '1') {
        // 技师列表
        replace('/technicianModule/technicianList/index')
      } else if (fromOrigin === '2') {
        // 发现
        replace('/trendsModule/trends/index')
      } else if (fromOrigin === '3') {
        // 订单列表
        replace('/orderModule/myOrders/index')
      } else if (fromOrigin === '4') {
        // 我的
        replace('/myModule/home/index')
      }
    }
  }
}
</script>

<template>
  <van-config-provider :theme-vars="themeVars">
    <van-popup v-model:show="isShowConfirmPopup" position="bottom" round closeable>
      <div class="pop-con flex_align_center">
        <div class="pop-subtit fs-14">{{ globalUgcTechDislikeInfo?.type === 0 ? '确定要将该技师移至屏蔽列表吗？' : '确定屏蔽他的所有动态吗？' }}</div>
        <div class="pop-tips fs-12 gray margin-t10">注意：后续可在 <span class="orange">设置-屏蔽列表</span> 中取消屏蔽</div>
        <div class="pop-btn flex_between margin-t30">
          <van-button @click.stop="isShowConfirmPopup = false">再想想</van-button>
          <van-button class="confirm" @click.stop="addOrRemove">确认</van-button>
        </div>
      </div>
    </van-popup>
  </van-config-provider>
</template>

<style scoped lang="scss">
.pop-con {
  padding: 38px 20px 20px;
  flex-direction: column;
  color: #333333;

  .pop-subtit {
    color: #333333;
    font-weight: 500;
    line-height: 24px;
  }

  .pop-tips {
    color: #767676;
    line-height: 24px;
    
    .orange {
      color: #FF5A13;
    }
  }

  .pop-btn {
    width: 100%;

    .van-button {
      width: 160px;
      height: 44px;
      background-color: #F5F6F8;
      border: none;
      border-radius: 22px;
      font-size: 15px;
      color: #1A1A1A;
      font-weight: 500;

      &.confirm {
        background-color: #FFE72B;
        color: #222425;
      }
    }
  }
}

:deep(.van-popup__close-icon) {
  width: 20px;
  height: 20px;
  background-color: #F5F6F8;
  border-radius: 50%;
  font-size: 12px;
  color: #333333;
  line-height: 20px;
  text-align: center;
  font-weight: bold;
}
</style>
